var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.2","baseProfile":"tiny","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 45.4 32.2","xml:space":"preserve"}},[_c('g',[_c('polygon',{attrs:{"points":"14.7,32.2 0,17.5 1.4,16 14.7,29.3 44,0 45.4,1.5 \t"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }